import { IS, getQuery } from '@da-vinci/utils'
import { LocaleType, changeUiLocale, useLocal as useLocalFn } from '@mogic/dv-design'
import ZH_CN from './zh-CN.json'
import en from './en.json'
import { apiT as apiTFn, IApiTProps, fallbackMsg } from './apiCode'

const messages = {
  [LocaleType.zhCN]: ZH_CN,
  [LocaleType.en]: en,
} as const satisfies Record<LocaleType, any>

export const useLocal = (opt: { LOCAL_KEY: string; oneLang?: LocaleType; onChange?: (locale: LocaleType) => any }) => {
  const { LOCAL_KEY, oneLang, onChange } = opt
  const {
    currentLocal,
    i18n,
    t: tFn,
    getLocaleMap,
    changeLocale,
  } = useLocalFn({
    messages,
    LOCAL_KEY,
  })
  const t: typeof tFn = (...args) => (IS.isNullOrUndef(args[0]) ? '' : tFn(...args))

  const changeLocaleFn = (locale: LocaleType) => {
    const change = locale !== currentLocal.value
    changeUiLocale(locale)
    changeLocale(locale)
    onChange && onChange?.(locale)
    if (change) {
      window.location.reload()
    }
  }
  if (oneLang) {
    changeLocaleFn(oneLang)
  } else {
    const nowLang = getLocaleMap(getQuery('lang') || currentLocal.value)
    changeLocaleFn(nowLang)
  }

  const apiT = (e: IApiTProps) => apiTFn(currentLocal.value, e)

  return { currentLocal, i18n, t, getLocaleMap, changeLocaleFn, apiT }
}

export { LocaleType, fallbackMsg }
export * from './dictionary'
